import React from 'react';

import { connect } from 'react-redux';

import { Stack, Box, Table } from '@nerdwallet/currency';
import { Num as num } from '@nerdwallet/nw-client-lib';

import { Browser } from '../../../types';
import { Outputs, CostSchedule } from '../types';

import Cta from './cta';
import PanelHeader from './panel-header';
import ResultsChart from './results-chart/results-chart';

export type ResultsPanelProps = {
  dispatch: (args: any) => void;
  trackingFormName: string;
  browser: Browser;
  outputs: Outputs;
  plannedStay: number;
};

type TableProps = {
  rentingScenario: CostSchedule;
  buyingScenario: CostSchedule;
  browser: Browser;
};

const getFormattedOutput = (property, data, browser) => {
  if (browser.isMobile) {
    return num.formatPercent(data[property] ?? 0, '$0a');
  }

  return num.formatCurrency(data[property] ?? 0, false);
};

const getTableProps = ({
  rentingScenario,
  buyingScenario,
  browser,
}: TableProps) => ({
  columns: [
    {
      id: 'column1',
      heading: 'Your cost breakdown',
    },
    {
      id: 'column2',
      heading: 'RENT',
    },
    {
      id: 'column3',
      heading: 'BUY',
    },
  ],
  data: [
    {
      key: 'monthly',
      column1: 'Monthly cost',
      column2: getFormattedOutput('monthlyCostNPV', rentingScenario, browser),
      column3: getFormattedOutput('monthlyCostNPV', buyingScenario, browser),
    },
    {
      key: 'total',
      column1: 'Total cost',
      column2: getFormattedOutput('totalCostNPV', rentingScenario, browser),
      column3: getFormattedOutput('totalCostNPV', buyingScenario, browser),
    },
  ],
});

const ResultsPanel = ({
  outputs,
  plannedStay,
  browser,
  trackingFormName,
}: ResultsPanelProps): JSX.Element => {
  const { rentingSchedule, buyingSchedule } = outputs;
  const rentingScenario = rentingSchedule[plannedStay - 1];
  const buyingScenario = buyingSchedule[plannedStay - 1];
  const benefitNPV = rentingScenario.totalCostNPV - buyingScenario.totalCostNPV;
  const monthlyDiff =
    rentingScenario.monthlyCostNPV - buyingScenario.monthlyCostNPV;

  return (
    <Stack>
      <Box padding="3">
        <PanelHeader monthlyDiff={monthlyDiff} benefitNPV={benefitNPV} />
        <ResultsChart trackingFormName={trackingFormName} />
        <Table
          {...getTableProps({ rentingScenario, buyingScenario, browser })}
        />
      </Box>
      <Cta />
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  outputs: state?.rentvsbuyCalculator?.outputs,
  plannedStay: state?.rentvsbuyCalculator?.plannedStay,
  browser: state?.browser,
});

export default connect(mapStateToProps)(ResultsPanel);
